module.exports = __webpack_public_path__ + "img/医生.23e62ccd.png";